module.exports = __webpack_public_path__ + "static/media/DSC_6832.c262a2c1.jpg";